// Łącznik w środku słowa („e-mail”, „E-Mail-Adresse”) to dla przeglądarki miejsce, w którym wolno
// złamać linię, więc na wąskim ekranie zdanie kończyło się „adres e-”, a „mail.” zaczynało
// następną linię (strona podziękowania po płatności, test na iPhonie 17, 18.10.2026). Łącznik
// między literami zamieniamy na niełamiący (U+2011), który wygląda tak samo.
export const LACZNIK_NIELAMIACY = '‑';

export function bezLamaniaNaLaczniku(tekst) {
  return String(tekst ?? '').replace(/(\p{L})-(?=\p{L})/gu, `$1${LACZNIK_NIELAMIACY}`);
}
